

























































import { Component, Vue } from 'vue-property-decorator';
import { ROLES } from '@/constants/user';
import UserListFilterForm from './List/UserListFilterForm.vue';
import UserListFilterChip from './List/UserListFilterChip.vue';

@Component({
  components: {
    UserListFilterForm,
    UserListFilterChip,
  },
})
export default class UserList extends Vue {
  // Data
  options = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: null,
    orderByDirection: 'asc',
    roles: [],
  };

  roles = ROLES;

  headers = [
    { text: 'Name', value: 'name' },
    {
      text: 'Last Seen',
      value: 'last_seen',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Registered At',
      value: 'created_at',
      align: 'left',
      sortable: false,
    },
    { text: 'Roles', value: 'user_roles', align: 'left', sortable: false },
  ];

  // Methods
  handleFetch() {
    return this.$store.dispatch('User/fetchList', {
      params: {
        search: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == 'desc'
            ? '-' + this.options.orderBy
            : this.options.orderBy,
        roles: this.options.roles,
        expand: [],
      },
    });
  }

  toRead(id) {
    this.$router.push({
      name: 'administrator-user-read',
      params: {
        userId: id,
      },
    });
  }

  test() {
    this.options.itemsPerPage = 20;
    this.handleFetch();
  }

  handleClick(item) {
    this.toRead(item.id);
  }
}
